<div class="">
  <div class="wrap_body mt-4">
    <div class="">
      <div class="m-head">
        <h4 class="d-block d-md-none">My Clients</h4>

        <div
          class="d-flex justify-content-end"
          *ngIf="authorizeService.canView('inviteInvestor') && appState.companyInfo$ | async as companyInfo"
        >
          <button
            type="submit"
            *ngIf="companyInfo?.appConfig?.investorInvitation?.isEnabled"
            cdkFocusInitial
            (click)="openInviteDialogBox()"
            mat-flat-button
            color="primary"
          >
            <mat-icon inline>person_add</mat-icon>
            Invite Investor
          </button>
        </div>
      </div>

      <div>
        <form [formGroup]="clientFilterForm">
          <div class="filter-section px-3 m-filter">
            <mat-form-field class="mr-5">
              <mat-label> Name </mat-label>
              <input
                matInput
                autocomplete="off"
                formControlName="searchClients"
                type="text"
                placeholder="Search Name"
              />
            </mat-form-field>
            <div>
              <span class="active-duration-label">Active in the last</span>
              <mat-form-field class="active-duration-value">
                <input
                  type="number"
                  formControlName="duration"
                  matInput
                  (input)="(selectDuration)"
                  [(ngModel)]="inputValue"
                  (ngModelChange)="onInputChange()"
                />
                <mat-error *ngIf="clientFilterForm.get('duration').hasError('pattern')" class="invalid-feedback">
                  Please enter a valid number</mat-error
                >
              </mat-form-field>
              <mat-error *ngIf="!isHourDurationValid || !isMinuteDurationValid" class="invalid-feedback ml-0 error-pos">
                Please enter a valid number</mat-error
              >
            </div>
            <mat-form-field class="active-duration-type">
              <mat-select
                formControlName="durationType"
                [(value)]="selectedDurationType"
                (selectionChange)="onDurationTypeChange()"
              >
                <mat-option value="minutes"> Minutes </mat-option>
                <mat-option value="hours"> Hours </mat-option>
                <mat-option value="days"> Days </mat-option>
                <mat-option value="weeks"> Weeks </mat-option>
                <mat-option value="month"> Months </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="agents" *ngIf="authorizeService.canView('agentIdFilter')">
              <mat-label>Agent</mat-label>
              <!-- (selectionChange)="agentSelected($event)" -->
              <mat-select formControlName="agentId">
                <mat-option value="all">All </mat-option>
                <mat-option *ngFor="let agent of agentIdList" [value]="agent.id">
                  {{ agent.firstName + ' ' + agent.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="status">
              <mat-label>Account status</mat-label>
              <!-- (selectionChange)="statusSelected($event)" -->
              <mat-select formControlName="verificationStatus" [(value)]="selectedVerificationStatus">
                <mat-option value="all">All </mat-option>
                <mat-option value="true">Verified </mat-option>
                <mat-option value="false">Unverified </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="leadFilter" class="status">
              <mat-label>Lead status</mat-label>
              <mat-select formControlName="leadStatus" multiple #leadSelect="matSelect">
                <!-- ✅ Header with Close Button -->

                <button class="float-right" mat-icon-button (click)="leadSelect.close()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-optgroup *ngFor="let leads of leadFilter" [label]="leads.name">
                  <mat-option
                    style="width: 100%"
                    *ngFor="let keyValuePair of leads.items | keyvalue"
                    [value]="{ type: leads.type, value: keyValuePair.key }"
                  >
                    {{ keyValuePair.value['displayText'] }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
            <app-select-search-dropdown
              class="agents"
              label="Agents"
              [options]="multiSelectOptions"
              [selected]="multiSelectOptions"
              [canSelectAll]="true"
              [multiple]="true"
              [required]="true"
              [isHideSearch]="clearSearch"
              [lazyLoadComplete]="!hasMoreClientUsers"
              (selectedEvent)="updateSelectedOptions($event)"
              (formValidEvent)="isClientFormValid = $event"
              (scrollEndEvent)="fetchNextClientUserList()"
              (searchEvent)="searchClientUser($event)"
              *ngIf="authorizeService.canView('clientIdFilter')"
            >
            </app-select-search-dropdown>

            <button
              color="primary"
              mat-flat-button
              (click)="filterData()"
              [disabled]="isDisableFilterBtn"
              class="ml-auto ml-lg-0"
            >
              Filter
            </button>
            <button
              mat-button
              color="primary"
              mat-stroked-button
              class="ml-2"
              [disabled]="isDisableResetBtn"
              (click)="resetFilter()"
            >
              Reset
            </button>
          </div>
        </form>
      </div>

      <div class="row mb-5">
        <div class="col-lg-12 mt-2">
          <div class="table_base">
            <div class="table-responsive table_wrap" #clientListContainer>
              <table
                mat-table
                [dataSource]="tableDataSource"
                class="mat-elevation-z2 w-100"
                matSort
                matSortActive="lastActivityDate"
                matSortDirection="desc"
                (matSortChange)="sortTable($event)"
              >
                <!-- <table mat-table [dataSource]="tableDataSource" class="mat-elevation-z2 w-100"> -->
                <ng-container matColumnDef="clientName">
                  <th mat-header-cell *matHeaderCellDef>Client Name</th>
                  <td mat-cell *matCellDef="let element">{{ element.firstName }} {{ element.lastName }}</td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Email</th>
                  <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                </ng-container>

                <ng-container matColumnDef="totalActivityScore">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Score</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.totalActivityScore ? (element.totalActivityScore | number: '1.0-0') : 0 }}
                    <span *ngIf="element.tag && element.tag?.length">
                      {{ +element.tag[2] || +element.tag[1] || +element.tag[0] || 0 | number: '1.0-0' }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="leadType">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Type</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.leadType | titlecase }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="leadStatus">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      appState?.companyInfoValue &&
                        appState.companyInfoValue[element.leadType + 'LeadCategory'] &&
                        appState.companyInfoValue[element.leadType + 'LeadCategory'][element.leadStatus].displayText
                        | titlecase
                    }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastActivityDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Activity Date</th>

                  <td mat-cell *matCellDef="let element">
                    {{ element.lastActivityDate | date: 'MMM d,  h:mm a' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="activationDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Connected On</th>
                  <td mat-cell *matCellDef="let element">{{ element.activationDate | simpleDate }}</td>
                </ng-container>
                <ng-container matColumnDef="connectionStatus">
                  <!-- *ngIf="(appState.companyInfo$ | async)?.type == 'default'"> -->
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Connection Status</th>
                  <td mat-cell *matCellDef="let element" class="capitalize">
                    {{ element.connectionStatus | titlecase }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="source">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Source</th>
                  <td mat-cell *matCellDef="let element" class="capitalize">
                    <span *ngIf="element.source && constant.SIGN_UP.sourceValue[element.source]">
                      <!-- {{ constant.SIGN_UP.sourceValue[element.source] }} -->
                      {{ getSourceValueWithoutFrom(element.source) }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="emailVerificationDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Account Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.emailVerificationDate != null ? 'Verified' : 'Unverified' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Capture Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.createdDate | simpleDate }}
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: tableColumnList" (click)="openClientDetailsSheet(row)"></tr>
              </table>
            </div>

            <div class="flex_center w-100" *ngIf="!isDataLoading && !investorUsersCount">
              <div class="notFound text-center noData">
                <div>
                  <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                  <h4>No active clients found</h4>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center">
              <button
                type="button"
                mat-button
                color="primary"
                [pmx-progress-button]="exportingInProgress"
                (click)="readyToExport()"
                [disabled]="investorUsersCount == 0"
                class="ml-3 m-export"
              >
                <mat-icon [inline]="true">download</mat-icon>
                Export
              </button>
              <mat-paginator
                [length]="investorUsersCount"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="[10, 20]"
                (page)="pageChange($event)"
                showFirstLastButtons
                class="d-inline-block m-wdh"
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-in-progress" *ngIf="isDataLoading">
      <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
      Please wait while we load
    </div>
  </div>
  <ng-template #inviteInvestorDialog>
    <button class="close" mat-button type="button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <form #form="ngForm" (submit)="inviteUser()" [formGroup]="investorInviteForm">
      <div class="addGroupWrap">
        <h2 matDialogTitle class="text-center">Invite Investor</h2>
        <div mat-dialog-content class="pt-2">
          <mat-form-field class="w-100">
            <mat-label>First Name </mat-label>
            <input formControlName="firstName" matInput type="text" required />
            <mat-error
              *ngIf="formControls.firstName.errors && formControls.firstName.errors.required"
              class="invalid-feedback"
            >
              First Name is required</mat-error
            >
            <mat-error
              *ngIf="formControls.firstName.errors && formControls.firstName.errors.maxlength"
              class="invalid-feedback"
            >
              Maximum 25 characters are allowed</mat-error
            >
            <mat-error
              *ngIf="formControls.firstName.errors && formControls.firstName.errors.pattern"
              class="invalid-feedback"
            >
              Only alphabets are allowed</mat-error
            >
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Last Name </mat-label>
            <input formControlName="lastName" matInput type="text" />
            <mat-error
              *ngIf="formControls.lastName.errors && formControls.lastName.errors.pattern"
              class="invalid-feedback"
              >Only alphabets are allowed</mat-error
            >
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Email </mat-label>
            <input formControlName="email" matInput type="email" required />
            <mat-error *ngIf="formControls.email.errors && formControls.email.errors.required" class="invalid-feedback">
              Email is required</mat-error
            >
            <mat-error *ngIf="formControls.email.errors && formControls.email.errors.pattern" class="invalid-feedback">
              Email must be a valid</mat-error
            >
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Phone Number </mat-label>
            <input matInput formControlName="phone" autocomplete="off" />
            <mat-error *ngIf="formControls.phone.errors && formControls.phone.errors.pattern" class="invalid-feedback">
              Phone number must be valid
            </mat-error>
          </mat-form-field>
        </div>
        <mat-dialog-actions>
          <div class="w-100 text-right">
            <!-- <button mat-button type="button" (click)="closeDialog()">Cancel</button> -->
            <button
              class="ml-1 btn-invite-investor"
              type="submit"
              cdkFocusInitial
              mat-flat-button
              color="primary"
              [pmx-progress-button]="isInvitingInvestor"
            >
              Invite
            </button>
          </div>
        </mat-dialog-actions>
      </div>
    </form>
  </ng-template>
</div>
